import { styled } from "@mui/material";
import { useDialogContext } from "./Dialog";
import { Form as FormikForm } from "formik";

interface DialogContentFormProps extends React.HTMLAttributes<HTMLFormElement> {}

/**
 * DialogContentForm is used to wrap the content of the dialog and it uses Formik's Form component
 * to handle form submission and validation.
 *
 * It also applies padding based on the dialog size (sm, md, lg).
 */
const DialogContentForm = styled((props: DialogContentFormProps) => {
  const { children, ...rest } = props;
  const dialogContext = useDialogContext();
  return (
    <FormikForm {...rest} data-size={dialogContext.size}>
      {children}
    </FormikForm>
  );
})(({ theme }) => ({
  height: "100%",
  width: "100%",
  backgroundColor: "white",
  overflowY: "auto",

  "&[data-size=sm]": {
    padding: theme.spacing(3, 3, 0, 3),
  },
  "&[data-size=md]": {
    padding: theme.spacing(3, 3, 0, 3),
  },
  "&[data-size=lg]": {
    padding: theme.spacing(3, 4, 0, 4),
  },
}));

export default DialogContentForm;
